import React, { useState } from "react";
import logo from "../assets/logo.png";
import LoginModal from "./LoginModal";

function Navbar() {
  const [hovered, setHovered] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior:"smooth" });
  };

  const links = [["Plans","plans"],["How It Works","howitworks"],["About","about"],["FAQ","faq"]];

  return (
    <>
      <nav style={{display:"flex", justifyContent:"space-between", alignItems:"center", padding:"0px 48px", height:"70px", background:"#fff", boxShadow:"0 2px 16px rgba(0,0,0,0.08)", position:"sticky", top:0, zIndex:100, borderBottom:"2px solid #0d9488", overflow:"visible"}}>
        <img src={logo} alt="Sajilo Policy" style={{height:"195px", objectFit:"contain", cursor:"pointer", position:"relative", zIndex:101}} onClick={() => scrollTo("top")} />

        <div style={{display:"flex", gap:"32px", alignItems:"center"}} className="desktop-nav">
          {links.map(([label, id]) => (
            <button key={id} onClick={() => scrollTo(id)}
              onMouseEnter={() => setHovered(id)}
              onMouseLeave={() => setHovered(null)}
              style={{background:"none", border:"none", cursor:"pointer", color: hovered === id ? "#0d9488" : "#374151", fontWeight:"600", fontSize:"15px", transition:"color 0.2s", borderBottom: hovered === id ? "2px solid #0d9488" : "2px solid transparent", paddingBottom:"2px"}}>
              {label}
            </button>
          ))}
          <button onClick={() => setShowLogin(true)}
            style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"999px", padding:"10px 24px", fontWeight:"700", fontSize:"15px", cursor:"pointer", boxShadow:"0 4px 16px rgba(13,148,136,0.4)", transition:"transform 0.2s"}}
            onMouseEnter={e => e.target.style.transform="scale(1.05)"}
            onMouseLeave={e => e.target.style.transform="scale(1)"}>
            Get Started →
          </button>
        </div>

        <button onClick={() => setMenuOpen(!menuOpen)}
          style={{display:"none", background:"none", border:"none", cursor:"pointer", flexDirection:"column", gap:"5px", padding:"4px", zIndex:102}}
          className="hamburger">
          <span style={{width:"24px", height:"2px", background:"#0d9488", display:"block", transition:"all 0.3s", transform: menuOpen ? "rotate(45deg) translateY(7px)" : "none"}}></span>
          <span style={{width:"24px", height:"2px", background:"#0d9488", display:"block", transition:"all 0.3s", opacity: menuOpen ? 0 : 1}}></span>
          <span style={{width:"24px", height:"2px", background:"#0d9488", display:"block", transition:"all 0.3s", transform: menuOpen ? "rotate(-45deg) translateY(-7px)" : "none"}}></span>
        </button>
      </nav>

      {menuOpen && (
        <div style={{position:"fixed", top:"70px", left:0, width:"100%", background:"#fff", zIndex:99, padding:"24px 32px", display:"flex", flexDirection:"column", gap:"16px", boxShadow:"0 8px 24px rgba(0,0,0,0.12)", borderTop:"1px solid #e2e8f0"}}>
          {links.map(([label, id]) => (
            <button key={id} onClick={() => scrollTo(id)}
              style={{background:"none", border:"none", cursor:"pointer", color:"#374151", fontWeight:"600", fontSize:"16px", textAlign:"left", padding:"8px 0", borderBottom:"1px solid #f1f5f9"}}>
              {label}
            </button>
          ))}
          <button onClick={() => { setMenuOpen(false); setShowLogin(true); }}
            style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"999px", padding:"12px 24px", fontWeight:"700", fontSize:"15px", cursor:"pointer", marginTop:"8px"}}>
            Get Started →
          </button>
        </div>
      )}

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
          nav { padding: 0 20px !important; }
        }
      `}</style>
    </>
  );
}

export default Navbar;